import _ from 'lodash';
import { determineErrorFromResponse } from 'helpers/ContentHelper';
import { getCollectionOrder } from './Helpers';
import {
  CLEAR_COLLECTION_PANELS,
  FETCH_COLLECTION_PANEL,
  FETCH_COLLECTION,
  INCREMENT_PANEL_RENDER_COUNT,
  RESET_PANEL_LOADED,
  RESET_PANEL_RENDER_COUNT,
  SET_COLLECTION_FORCE_KEYART_FOR_SHOWCASE,
  SET_COLLECTION_USE_SHOWCASE_FALLBACK,
  SET_COLLECTION,
  SET_USER_BOOKMARKS,
  UPDATE_COLLECTION_ORDER,
  UPDATE_SHOWCASE_VIDEO,
  UPDATE_VISIBLE_ELEMENTS,
} from './Actions';

const INITIAL_STATE = {
  panels: null,
  panelRenderCount: null,
  seo: null,
  errors: null,
  visibleCollections: {},
  useShowcaseFallback: null,
  collectionOrder: [],
  forceKeyartForShowcase: false,
  isPanelLoaded: false,
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  const seo = _.get(action, 'payload.collection.seo', null);
  switch (action.type) {
    case CLEAR_COLLECTION_PANELS: {
      return {
        ...state,
        panels: null,
        seo: null,
        useShowcaseFallback: null,
        showcaseFallback: null,
        collectionOrder: [],
        isPanelLoaded: false,
      };
    }
    case FETCH_COLLECTION: {
      if (errors) return { ...state, errors };
      return state;
    }
    case FETCH_COLLECTION_PANEL: {
      const { panels } = state;
      const data = action?.payload?.data;
      const id = data?.['@id'];
      const panelData = data?.member;
      const panelHeadline = data?.headline;

      panels?.member?.map(panel => {
        if (panel?.['@id']?.includes(id)) {
          /* eslint-disable no-param-reassign */
          const defaultPanelHeadline = panel.headline;
          panel.headline = panelHeadline || defaultPanelHeadline;
          panel.items.member = panelData;
        }
      });

      return {
        ...state,
        isPanelLoaded: true,
      };
    }
    case SET_COLLECTION: {
      const payload = _.get(action, 'payload');
      const panels = _.get(payload, 'collection');
      const initialShowcase = _.get(payload, 'initialShowcase');
      const members = _.get(panels, 'member', []);
      const showcaseFallback = _.find(members, { collectionType: 'showcase-fallback' });

      return {
        ...state,
        panels,
        seo,
        showcaseFallback,
        initialShowcase,
        useShowcaseFallback: false,
        collectionOrder: getCollectionOrder(panels),
        forceKeyartForShowcase: false,
      };
    }
    case SET_COLLECTION_USE_SHOWCASE_FALLBACK: {
      return {
        ...state,
        useShowcaseFallback: action.payload,
        forceKeyartForShowcase: false,
      };
    }
    case SET_COLLECTION_FORCE_KEYART_FOR_SHOWCASE: {
      return {
        ...state,
        forceKeyartForShowcase: action.payload,
      };
    }
    case UPDATE_VISIBLE_ELEMENTS: {
      return {
        ...state,
        visibleCollections: action.payload,
      };
    }
    case UPDATE_COLLECTION_ORDER: {
      const collectionToRemove = action.payload;
      const { collectionOrder } = state;
      const collectionIds = collectionOrder;
      _.remove(collectionIds, id => id === collectionToRemove);
      return {
        ...state,
        collectionOrder: collectionIds,
      };
    }
    case UPDATE_SHOWCASE_VIDEO: {
      const video = action.payload;
      const { panels } = state;
      if (!video || !panels) return state;
      const member = _.get(panels, 'member', []);
      const newMember = _.map(member, panel => {
        const collectionType = _.get(panel, 'collectionType');
        if (collectionType !== 'showcase') return panel;
        const itemsData = _.get(panel, 'items', {});
        return {
          ...panel,
          items: {
            ...itemsData,
            member: [video],
          },
        };
      });
      const newPanels = { ...panels, member: newMember };
      return {
        ...state,
        panels: newPanels,
      };
    }
    case INCREMENT_PANEL_RENDER_COUNT: {
      const { panelRenderCount } = state;
      return {
        ...state,
        panelRenderCount: panelRenderCount + 1,
      };
    }
    case SET_USER_BOOKMARKS: {
      const { bookmarks } = action.payload;
      return {
        ...state,
        bookmarks,
      };
    }
    case RESET_PANEL_RENDER_COUNT: {
      return {
        ...state,
        panelRenderCount: null,
      };
    }
    case RESET_PANEL_LOADED: {
      return {
        ...state,
        isPanelLoaded: false,
      };
    }
    default:
      return state;
  }
}
